/* eslint-disable @angular-eslint/prefer-standalone */
import { Component } from '@angular/core';
import { TranslationKeys } from '@internationalization/translation-keys';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { VaultBaseComponent } from '@shared/components/base/vault-base.component';
import { selectAuthState } from '@state/auth/auth.selectors';
import { AuthState } from '@state/auth/auth.state';
import { AppState } from '@state/index';
import { Subject, takeUntil } from 'rxjs';

@Component({
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
  standalone: false,
})
export class CreatePasswordComponent extends VaultBaseComponent {
  private destroy$ = new Subject<void>();
  public currentAuthState: AuthState = {} as AuthState;
  loadingMessage: string | null = null;

  constructor(store: Store<AppState>, translateService: TranslateService) {
    super(translateService, store);

    store
      .select(selectAuthState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((authState: AuthState) => {
        this.currentAuthState = authState;
      });

    this.loadingMessage = translateService.instant(TranslationKeys.General.Loading);
  }
}
